// extracted by mini-css-extract-plugin
module.exports = {"menu":"DropDownMenu_menu__14KKZ","menuWithScroll":"DropDownMenu_menuWithScroll__16ZjH","scrollBarContainer":"DropDownMenu_scrollBarContainer__Y3vRO"};